import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Text } from 'exoflex';

import { BLACK_OPACITY, TEXT } from '../constants/colors';

type Props = {
  numDay: string | null;
  descText: string;
};

export default function DateCircleSummaryCard({ numDay, descText }: Props) {
  return (
    <View style={styles.circleContainer}>
      <Text weight="medium" style={[styles.textStyle, styles.numDayText]}>
        {numDay}
      </Text>
      <Text weight="normal" style={[styles.textStyle, styles.descText]}>
        {descText}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  circleContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: BLACK_OPACITY,
    width: 84,
    height: 84,
    borderRadius: 84 / 2,
  },
  textStyle: {
    color: TEXT.white,
  },
  numDayText: {
    fontSize: 20,
  },
  descText: {
    fontSize: 10,
    marginTop: 2,
    textAlign: 'center',
  },
});
